// @flow

import {
  HeaderProvider,
  useAuthentication,
} from '@travel-frontend/ui-components';
import {isEmpty} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';

import {setDataTakenAfterLogin} from 'redux/uiState/profile/actions';
import {getData} from 'redux/v1/customer/data/reducer';

export const HeaderWrapper = ({children}) => {
  const dispatch = useDispatch();
  const customer = useSelector(getData);

  const {toggleWidget} = useAuthentication();

  const handlers = {
    onLoginClick: () => {
      dispatch(setDataTakenAfterLogin(false));
      if (!isEmpty(customer)) toggleWidget('checkoutSignIn');
    },
  };

  return <HeaderProvider value={{handlers}}>{children}</HeaderProvider>;
};
